<form [formGroup]="form" (ngSubmit)="handleSubmit()">
  <h2 mat-dialog-title>{{ 'PAYMENTS_EXPORT.DIALOG.TITLE' | translate }}</h2>
  <mat-dialog-content>
    <glxy-alert class="alert" type="error" *ngIf="errorMessage$ | async as errorMessage" class="error">
      {{ errorMessage }}
    </glxy-alert>

    <glxy-alert type="info">{{ 'PAYMENTS_EXPORT.DIALOG.PATIENCE_MESSAGE' | translate }}</glxy-alert>

    <glxy-form-field>
      <glxy-label>{{ 'PAYMENTS_EXPORT.DIALOG.DATE_RANGE' | translate }}</glxy-label>
      <mat-select formControlName="basicDate">
        <mat-option *ngFor="let option of basicDateOptions" [value]="option.value">
          {{ option.label }}
        </mat-option>
      </mat-select>
    </glxy-form-field>

    <glxy-form-field *ngIf="basicDate === BasicDate.CUSTOM">
      <mat-date-range-input [rangePicker]="picker" [max]="today">
        <input matStartDate placeholder="Start date" formControlName="startInterval" />
        <input matEndDate placeholder="End date" formControlName="endInterval" />
      </mat-date-range-input>
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>
    </glxy-form-field>

    <glxy-form-field>
      <glxy-label>{{ 'PAYMENTS_EXPORT.DIALOG.CURRENCY' | translate }}</glxy-label>
      <mat-select formControlName="currency">
        <mat-option *ngFor="let option of currencyOptions" [value]="option.id">
          {{ option.name }}
        </mat-option>
      </mat-select>
      <glxy-hint>{{ 'PAYMENTS_EXPORT.DIALOG.CURRENCY_HINT' | translate }}</glxy-hint>
    </glxy-form-field>

    <div class="report-data-hint">{{ 'PAYMENTS_EXPORT.DIALOG.REPORT_DATA_HINT' | translate }}</div>
    <div class="report-data-hint">{{ 'PAYMENTS_EXPORT.DIALOG.DATE_HINT' | translate }}</div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button type="button" mat-stroked-button (click)="handleCancel()">
      {{ 'PAYMENTS_EXPORT.DIALOG.CANCEL' | translate }}
    </button>
    <button type="submit" mat-flat-button color="primary" [disabled]="downloading$ | async">
      <glxy-button-loading-indicator [isLoading]="downloading$ | async">
        {{ 'PAYMENTS_EXPORT.DIALOG.EXPORT' | translate }}
      </glxy-button-loading-indicator>
    </button>
  </mat-dialog-actions>
</form>

<ng-template #loadingCurrencies>
  <mat-dialog-content class="loading">
    <mat-spinner [diameter]="30"></mat-spinner>
  </mat-dialog-content>
</ng-template>
